import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {FooterDataService} from '../footer/footer-data.service';

@Component({
    selector: 'app-about-page',
    templateUrl: './about-page.component.html',
    styleUrls: ['./about-page.component.scss']
})
export class AboutPageComponent implements OnInit {

    constructor(
        private auth: AuthService,
        private service: FooterDataService,
    ) {
    }

    ngOnInit(): void {
    }

    subscribe() {
        this.service.subscribe()
            .subscribe();
    }

    unsuscribe() {
        this.service.unsubscribe()
            .subscribe();
    }

    get subscribed() {
        return this.auth.userState.subscribed;
    }
}
